import React, { useEffect, useState } from 'react'
import { getTestimoniList } from '../../../../services/testimoni'
import { Box, Text, Grid, Progress, Paper, Avatar, Rating, Flex, Center } from '@mantine/core'
import { getImageFile } from '../../../../services/fileImage'
import LoadingSection from '../../../ui/LoadingSection'
import { useViewportSize } from '@mantine/hooks'
import dayjs from 'dayjs-ext'
import relativeTime from 'dayjs-ext/plugin/relativeTime'

dayjs.extend(relativeTime)


const ReviewProgram = ({ eventId }) => {
  const { width } = useViewportSize()
  const [loadingSummary, setLoadingSummary] = useState(true)
  const [loadingReview, setLoadingReview] = useState(true)
  const [reviewList, setReviewList] = useState([])
  const [dataSummary, setDataSummary] = useState(null)

  const handleGetReviewProgram = async () => {
    setLoadingSummary(dataSummary !== null ? false : true)
    setLoadingReview(true)
    const defaultParameter = {
      event: eventId,
      orderBy: 'createdAt',
      order: 'desc',
      skip: 0,
      take: 10
    }
    try {
      const response = await getTestimoniList(defaultParameter)
      if (dataSummary === null) {
        setDataSummary(response.summary)
      }
      setReviewList(response.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSummary(false)
      setLoadingReview(false)
    }
  }

  useEffect(() => {
    if (eventId) {
      handleGetReviewProgram()
    }
    // eslint-disable-next-line
  }, [eventId])

  const mappingSummaryReview = (data) => {
    if (data) {
      return (
        <Box>
          <Grid align='center'>
            <Grid.Col span='content'>
              <Paper shadow="sm" radius="md" p="md" style={{ backgroundColor: '#043056' }}>
                <Center w={width > 768 ? 70 : 30} h={width > 768 ? 70 : 30}>
                  <Text fz={width > 768 ? 45 : 18} fw='bold' c='white'>{data.average || 0}</Text>
                </Center>
              </Paper>
            </Grid.Col>
            <Grid.Col span={8}>
              <Flex gap='sm' align='center' mb={3}>
                <Box w={width > 768 ? 350 : 100}>
                  <Progress color='#E72E12' size={width > 768 ? 'lg' : 'sm'} value={(data.star5Count / data.totalCount) * 100} />
                </Box>
                <Rating value={5} fractions={5} readOnly size={width > 768 ? 'md' : 'xs'} />
              </Flex>
              <Flex gap='sm' align='center' mb={3}>
                <Box w={width > 768 ? 350 : 100}>
                  <Progress color='#E72E12' size={width > 768 ? 'lg' : 'sm'} value={(data.star4Count / data.totalCount) * 100} />
                </Box>
                <Rating value={4} fractions={5} readOnly size={width > 768 ? 'md' : 'xs'} />
              </Flex>
              <Flex gap='sm' align='center' mb={3}>
                <Box w={width > 768 ? 350 : 100}>
                  <Progress color='#E72E12' size={width > 768 ? 'lg' : 'sm'} value={(data.star3Count / data.totalCount) * 100} />
                </Box>
                <Rating value={3} fractions={5} readOnly size={width > 768 ? 'md' : 'xs'} />
              </Flex>
              <Flex gap='sm' align='center' mb={3}>
                <Box w={width > 768 ? 350 : 100}>
                  <Progress color='#E72E12' size={width > 768 ? 'lg' : 'sm'} value={(data.star2Count / data.totalCount) * 100} />
                </Box>
                <Rating value={2} fractions={5} readOnly size={width > 768 ? 'md' : 'xs'} />
              </Flex>
              <Flex gap='sm' align='center' mb={3}>
                <Box w={width > 768 ? 350 : 100}>
                  <Progress color='#E72E12' size={width > 768 ? 'lg' : 'sm'} value={(data.star1Count / data.totalCount) * 100} />
                </Box>
                <Rating value={1}  fractions={5} readOnly size={width > 768 ? 'md' : 'xs'} />
              </Flex>
            </Grid.Col>
          </Grid>
        </Box>
      )
    }
  }

  const mappingListReview = (dataReview) => {
    if (dataReview.length > 0) {
      const remapDataReview = dataReview.map((val, index) => {
        const dataReview = val.userEventCompletion

        const mappingDataUser = (dataUser) => {
          const profileUser = dataUser.profile
          if (profileUser !== null) {
            if (dataUser.profile.status === 'bekerja') {
              return `${profileUser.company} ${profileUser.job ? `- ${profileUser.job}` : ''}` 
            } else if (profileUser.status === 'pelajar') {
              return `${profileUser.institution} ${profileUser.department ? `- ${profileUser.department}` : ''}`
            }
          } else {
            const statusUser = reviewList.length > 0 ? `Peserta ${reviewList[0].event.name}` : 'Peserta'
            return statusUser
          }
        }
        return (
          <Paper shadow="sm" radius="md" p="lg" withBorder key={index} mb={8}>
            <Flex gap='xs' align='center' mb={4}>
              <Rating value={dataReview.userRating} fractions={5} size='xs' readOnly />
              <Text fz={12} c='dimmed'>{dayjs(val.createdAt).diff(new Date(), 'day') < -7 ? dayjs(dayjs(val.createdAt).format('YYYY-MM-DD')).fromNow() : dayjs(val.createdAt).format('DD MMMM YYYY')}</Text>
            </Flex>
            <Box h={70} mb={4}>
              <Text fz={12} c='dark' lineClamp={4}>{dataReview.feedback?.mostLiked || dataReview.userComment}</Text>
            </Box>
            <Box>
              <Flex gap='sm' align='center'>
                <Avatar size='md' radius="xl" src={dataReview.userEvent.user.image !== null ? getImageFile(dataReview.userEvent.user.image) : null} />
                <Box>
                  <Text fw='600' fz={12} mb={2} lineClamp={1}>{dataReview.userEvent.user.fullName}</Text>
                  <Text fw='500' fz={11} mb={2} lineClamp={2}>{mappingDataUser(dataReview.userEvent.user)}</Text>
                </Box>
              </Flex>
            </Box>
          </Paper>
        )
      })

      return remapDataReview
    } else {
      return (
        <Box ta='center' my={120}>
          <Text c="dark">Belum ada testimoni dari peserta</Text>
        </Box>
      )
    }
  }

  const mappingReview = (dataReview) => {

    return (
      <Paper shadow="sm" radius="md" p="lg" withBorder style={{ backgroundColor: '#F3F3F3' }}>
        <Text fz="md" fw="bold">Rating & Review</Text>
        <Box my={12}>
          {mappingSummaryReview(dataSummary)}
        </Box>
        <Box my={30}>
          {mappingListReview(reviewList)}
        </Box>
      </Paper>
    )
  } 

  return (
    <Box>
      {loadingSummary && loadingReview ? <LoadingSection /> : mappingReview(reviewList)}
    </Box>
  )
}

export default ReviewProgram